import { type Reviews } from '@vakantiesnl/types';
import { isNumber } from 'lodash';

const mapSubScores = (aspects: Reviews.ReviewView['aspects']): Reviews.ReviewSubscores['subscores'] => {
	const subScores: Reviews.ReviewSubscores['subscores'] = [];
	if (!aspects) return;
	Object.entries(aspects).forEach(([key, value]) => {
		if (value) {
			subScores.push({
				label: key,
				rating: value,
			});
		}
	});
	return subScores;
};

export const calcOverallRating = (ratings?: Record<string, number>[]): number | undefined => {
	const ratingSummary = ratings
		?.map((item) => item['key'] * item['count'])
		.reduce((accumulator, currentValue) => accumulator + currentValue, 0);

	const ratingCount = ratings
		?.map((item) => item['count'])
		.reduce((accumulator, currentValue) => accumulator + currentValue, 0);

	const divided = isNumber(ratingSummary) && isNumber(ratingCount) ? ratingSummary / ratingCount : undefined;

	return !!divided ? Math.round(divided * 10) / 10 : undefined;
};

export const mapReviewResponse = (
	response: Reviews.ResponseBody,
	pageParam: Reviews.PageParam,
): Reviews.MappedReviewResponse => {
	const reviews = response.data.map((item) => {
		const subScores = mapSubScores(item.aspects);

		return {
			...item,
			subscores: subScores,
		};
	});

	const overallRating = calcOverallRating(response.metadata.aggregations?.ratings);

	return {
		reviews,
		pageParam,
		total: response.metadata.totalCount,
		rating: overallRating,
	};
};
